/*
 * @Author: zhu.huijun
 * @Date: 2021-06-28 10:20:10
 * @Last Modified by: way
 * @Last Modified time: 2022-02-25 10:35:00
 */
import React, { useState, useEffect } from 'react';
import {connect, useSelector} from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import {Table, Icon, message, Modal} from '@whalecloud/fdx';
import {doCurrencyPrecision, fixZeroPrecision, getBusinessI18n, showTotal} from '@/utils';
import { StepFooter } from '@/components';

import styles from './index.module.less';

function SubscriberSelection (props) {
  const {
    loading = false,
    dealerEventCode,
    custId,
    needParentOpt = true, // 对主订户操作 默认为 true
    needChildOpt = true, // 对成员订户操作 默认为 true
    modelKey,
    qryParams = {}, // 订户列表查询条件
    onNext,
    onPrevious,
    dispatch,
  } = props;
  const { DRM_DEF_CURRENCY_PRECISION, DRM_CURRENCY_SHOW_PRECISION } = useSelector(state => state.business);
  const [subsList, setSubsList] = useState([]); // 订户列表
  const [selectSubsInfo, setSelectSubsInfo] = useState(); // 选中的订户信息

  const columns = [
    {
      title: i18n('CUST_MOBILE_NUMBER'), // Service Number
      dataIndex: 'accNbr',
      key: 'accNbr',
      className: styles.numberColumn,
    },
    {
      title: i18n('SEARCH_SERVICE_TYPE'), // Service Type
      dataIndex: 'serviceTypeName',
      key: 'serviceTypeName',
    },
    {
      title: i18n('SEARCH_SUB_SERVICE_TYPE'), // Sub Service Type
      dataIndex: 'prodName',
      key: 'prodName',
    },
    {
      title: i18n('SELECT_OFFER_PLAN_NAME'), // Plan Name
      dataIndex: 'offerName',
      key: 'offerName',
    },
    {
      title: i18n('TABLE_STATUS'), // Status
      dataIndex: 'stateName',
      key: 'stateName',
    },
  ];

  const handleSubsListSearch = params => {
    dispatch({
      type: 'subsSelection/qrySubsList',
      payload: params,
    }).then((res = {}) => {
      const { subsDtoList: allSubsDtoList } = res;
      const subsDtoList = (allSubsDtoList || []).filter(item => item.available_flag === 'Y'); // 过滤出可用的
      let subsTree = (subsDtoList || []).filter(it => !it.parentSubsId) || [];
      subsTree = subsTree.map(parent => {
        const childrenObj = {};
        if (subsDtoList.find(it => it.parentSubsId === parent.subsId)) {
          childrenObj.children = subsDtoList.filter(it => it.parentSubsId === parent.subsId);
        }
        return {
          ...parent,
          ...childrenObj,
        };
      });
      setSubsList(subsTree);
    });
  };

  useEffect(() => {
    if (!isEmpty(custId)) {
      const params = {
        custId,
        dealerEventCode,
        ...qryParams,
      };
      handleSubsListSearch(params);
    }
  }, [custId]);

  const renderExpandIcon = columnsInfo => {
    const { expanded, record } = columnsInfo;
    return (
      <span className={styles.cloumnsIcon}>
        {
          record.children ? (
            <Icon type={expanded ? 'caret-down' : 'caret-right'} />
          ) : ''
        }
      </span>
    );
  };

  const onPageChange = () => {};

  const handleRowClick = record => {
    if (get(selectSubsInfo, 'subsId') === record.subsId) {
      return;
    }
    setSelectSubsInfo(null);
    if (modelKey === 'changeOfIndicatorNormal' && `${record.serviceType}` === '81') {
      // 2797810 BSNL-DSCM-Fiber Combo下的Load Bearing Line不支持改号
      return;
    }
    if (!record.children && !record.parentSubsId) { // 非 combo 业务没有限制
      setSelectSubsInfo(record);
      return;
    }
    // * 2、combo业务下
    // * 2.1重装、移机、过户、切换主套餐，只能针对主订户操作
    // * 2.2固话换号、变更固话群组、变更宽度网络IP，只能针对成员订户操作
    // * 2.3拆机、变更VAS、变更实物，既能针对主订户操作，也能针对成员订户操作
    // * 2.4延长临时开户有效期，既不能针对主订户操作，也不能针对成员订户操作
    if (needParentOpt && needChildOpt) { // 对主订户和成员订户都能操作
      setSelectSubsInfo(record);
    } else if (needParentOpt && !record.parentSubsId) { // 只对主订户操作
      setSelectSubsInfo(record);
    } else if (needChildOpt && record.parentSubsId) { // 只对成员订户操作
      setSelectSubsInfo(record);
    }
  };

  const rowClassName = record => {
    if (get(selectSubsInfo, 'subsId') === record.subsId) {
      return styles.rowClickBackground;
    }
    return '';
  };

  const handleSubsInfoSave = async () => {
    if (isEmpty(selectSubsInfo)) {
      message.warning(i18n('MESSAGE_SUBS_SELECT_WARN'));
      return;
    }
    const subsDetail = (subsList.find(it => it.subsId === selectSubsInfo.subsId)) || selectSubsInfo;
    // 如果是过户或移机需要校验账户是否欠费
    if (modelKey === 'transfer' || modelKey === 'shift') {
      const rtn = await dispatch({
        type: 'business/queryAccountBsnl',
        payload: {
          accountCode: subsDetail.acctNbr,
        },
      });

      if (+rtn.totalDue > 0) {
        Modal.confirm({
          title: getBusinessI18n('OUTSTANDING_DETAILS'),
          content: (
            <div className={styles.detailWarp}>
              <div className={styles.detailTop}>
                <div className={styles.detailTopRow}>
                  <span>{getBusinessI18n('SERVICE_NUMBER')}</span>
                  <span>{subsDetail.accNbr}</span>
                </div>
                <div className={styles.detailTopRow}>
                  <span>{getBusinessI18n('ACCOUNT_NUMBER')}</span>
                  <span>{subsDetail.acctNbr}</span>
                </div>
              </div>
              <div className={styles.detailBottom}>
                <div className={styles.detailBottomRow}>
                  <span>{getBusinessI18n('TOTAL_OUTSTANDING')}</span>
                  <span>{fixZeroPrecision(doCurrencyPrecision(+rtn.totalDue, DRM_DEF_CURRENCY_PRECISION), DRM_CURRENCY_SHOW_PRECISION, true)}</span>
                </div>
              </div>
              <div className={styles.detailOperateGuide}>
                <div className={styles.detailOperateGuideRow}>
                  <span>{`Please pay the outstanding and initiate the ${modelKey} service again.`}</span>
                </div>
              </div>
            </div>
          ),
          className: 'alartWarp hasTitleAlartWarp',
          okText: i18n('COMMON_CONFIRM'),
          cancelText: i18n('COMMON_CANCEL'),
          cancelButtonProps: { className: styles.detailCancelButton },
          onOk: () => {
            // 退出流程回到首页
            dispatch({ type: `${modelKey}/clear` });
            dispatch({
              type: `${modelKey}/save`,
              payload: {
                step: 0,
              },
            });
          },
          onCancel: () => {},
          width: 566,
        });
        return;
      }
    }
    // 根据订户信息，保存serviceType和subServiceType，兼容一些显示场景
    const serviceType = {
      serviceType: subsDetail.serviceType,
      serviceTypeName: subsDetail.serviceTypeName,
    };
    const subServiceType = {
      subServiceType: subsDetail.prodId,
      subServiceTypeName: subsDetail.prodName,
    };
    await dispatch({
      type: `${modelKey}/save`,
      payload: {
        selectSubsInfo: subsDetail,
        serviceType,
        subServiceType,
      },
    });
    onNext();
  };

  return (
    <div className={`threeColumnWrap ${styles.subsSelectionTable}`}>
      <div className={`blockWrap ${styles.tableContent}`}>
        <h3 className="blockTitle">{i18n('SUBS_CARD_LIST_TITLE')}</h3>
        <div className={styles.tableData}>
          <Table
            loading={loading}
            rowKey="subsId"
            columns={columns}
            dataSource={subsList}
            expandRowByClick
            indentSize={12}
            expandIcon={renderExpandIcon}
            rowClassName={rowClassName}
            pagination={{
              onChange: onPageChange,
              hideOnSinglePage: true,
              showTotal,
            }}
            position="bottom"
            onRow={record => ({
              onClick: () => handleRowClick(record),
            })}
          />
        </div>
      </div>
      <StepFooter onPrevious={onPrevious} onContinue={handleSubsInfoSave} />
    </div>
  );
}

export default connect(({ loading }) => ({
  loading: loading.effects['subsSelection/qrySubsList'],
}))(SubscriberSelection);
